import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

export function UpgradeNote({ text, testId = "upgrade-note", compact = false }) {
  return (
    <div data-testid={testId} className={`flex flex-wrap items-center gap-3 rounded-xl border border-aqua/30 bg-aqua-soft ${compact ? "px-4 py-3" : "p-5"} text-sm text-ink`}>
      <Lock className="h-4 w-4 shrink-0 text-aqua" />
      <p className="flex-1">{text}</p>
      <Link to="/pricing" data-testid={`${testId}-link`} className="inline-flex items-center gap-1 rounded-full bg-solid px-4 py-1.5 text-xs font-semibold text-white transition-transform hover:-translate-y-0.5">
        View plans <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}
